import React from 'react'
import ContentLoader from 'react-content-loader'

const Placeholder = (props) => (
  <ContentLoader
    speed={2}
    width={351}
    height={313}
    viewBox="0 0 351 313"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="10" y="49" rx="0" ry="0" width="331" height="35" />
    <rect x="10" y="109" rx="0" ry="0" width="71" height="104" />
    <rect x="93" y="109" rx="0" ry="0" width="54" height="104" />
    <rect x="160" y="109" rx="0" ry="0" width="100" height="104" />
    <rect x="272" y="109" rx="0" ry="0" width="71" height="104" />
    <rect x="10" y="225" rx="0" ry="0" width="134" height="20" />
    <rect x="180" y="225" rx="0" ry="0" width="164" height="66" />
  </ContentLoader>
)

export default Placeholder
